module.exports = "/_next/static/images/119aef5781f78f7d3f506ebde732cccb-missing-info.svg";